module.exports = __webpack_public_path__ + "img/cup.e97ed0.svg";